// BugHerd feedback widget loader — DEV ONLY.
//
// The widget is gated on the REACT_APP_BUGHERD_KEY build-time env var. It is set
// in the DEV deployment pipeline (deploy-dev.yml, from the REACT_APP_BUGHERD_KEY
// repo secret) so QA testers get the widget on the deployed DEV site, and in
// each dev's git-ignored .env.local for local dev. Production builds never set
// it, so the script is never injected there. There is no fallback key on
// purpose: no key means no widget.
const BUGHERD_SRC = "https://www.bugherd.com/sidebarv2.js";

let injected = false;

export function initBugHerd() {
  if (injected) return;
  if (typeof document === "undefined") return;

  const apiKey = process.env.REACT_APP_BUGHERD_KEY;
  if (!apiKey) return;

  injected = true;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = `${BUGHERD_SRC}?apikey=${encodeURIComponent(apiKey)}`;
  document.head.appendChild(script);
}
